import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Shield, XCircle, Loader2 } from "lucide-react";
import { Button } from "../../components/ui/button";
import api from "../../lib/api";

import { useAppConfig } from "../../lib/AppConfigContext";

export default function AdminCancelDeletionPage() {
  const { t } = useTranslation();
  const { appName } = useAppConfig();
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);

  useEffect(() => {
    cancelDeletion();
  }, [token]);

  const cancelDeletion = async () => {
    try {
      const response = await api.get(`/admin/cancel-deletion/${token}`);
      setResult({ success: true, message: response.data.message });
    } catch (error) {
      setResult({ success: false, message: error.response?.data?.detail || "Enllaç invàlid o ja utilitzat" });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900">
        <Loader2 className="h-8 w-8 animate-spin text-slate-400" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        {/* Logo */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-12 h-12 bg-amber-600 rounded-xl flex items-center justify-center">
            <Shield className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="font-heading font-bold text-xl text-white">{appName}</h1>
            <p className="text-sm text-slate-400">{t('admin.adminPanel')}</p>
          </div>
        </div>

        {/* Card */}
        <div className="bg-slate-800 rounded-xl border border-slate-700 p-8 text-center">
          {result?.success ? (
            <>
              <div className="w-16 h-16 bg-blue-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                <XCircle className="h-8 w-8 text-blue-400" />
              </div>
              <h2 className="text-xl font-bold text-white mb-2">{t('cancelDeletion.title')}</h2>
              <p className="text-slate-400 mb-6">{result.message}</p>
            </>
          ) : (
            <>
              <div className="w-16 h-16 bg-red-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                <XCircle className="h-8 w-8 text-red-400" />
              </div>
              <h2 className="text-xl font-bold text-white mb-2">{t('admin.invalidLink')}</h2>
              <p className="text-slate-400 mb-6">{result?.message}</p>
            </>
          )}
          <Button
            onClick={() => navigate("/admin/dashboard")}
            className="bg-slate-700 hover:bg-slate-600"
          >
            Tornar al Dashboard
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
